export { modalPropsState } from "./modal-props";
